import QuoteSlide from './quote'
export default QuoteSlide
